import { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { getIsActive, getQueryValue } from '../../../utils'
import { IPublicCompany } from '../../../types'

type Props = {
  company: IPublicCompany
}

export const CompanyDetailNavbar: FC<Props> = observer(({ company }) => {
  const { t } = useTranslation(['companies-users-[id]'])
  const router = useRouter()
  const companySlug = getQueryValue('id', router)
  const common = [
    {
      label: t('会社情報'),
      href: `/companies/${companySlug}`,
      isActive: getIsActive(['/companies/[id]'], router, true, true),
    },
    {
      label: t('Jobs/求人'),
      href: `/companies/${companySlug}/jobs`,
      isActive: getIsActive(['/companies/[id]/jobs'], router, true, true),
    },
    {
      label: t('ストーリー'),
      href: `/companies/${companySlug}/articles`,
      isActive: getIsActive(['/companies/[id]/articles'], router, true, true),
    },
    {
      label: t('フォロワー'),
      href: `/companies/${companySlug}/followers`,
      isActive: getIsActive(['/companies/[id]/followers'], router, true, true),
    },
  ]
  const forVc = [
    {
      label: t('投資先求人'),
      href: `/companies/${companySlug}/startup-jobs`,
      isActive: getIsActive(['/companies/[id]/startup-jobs'], router, true, true),
    },
  ]
  const reference = [
    {
      label: t('応援コメント'),
      href: `/companies/${companySlug}/references`,
      isActive: getIsActive(['/companies/[id]/references'], router, true, true),
    },
  ]
  let items = company?.isVc ? common.concat(forVc) : common
  items = items.concat(reference)

  return (
    <div className={styles.container}>
      {items.map((item) => (
        <div key={item.label} className={item.isActive ? styles.activeItem : styles.menuItem}>
          <div className={styles.enclose}>
            <Link href={item.href}>
              <a>{item.label}</a>
            </Link>
          </div>
        </div>
      ))}
    </div>
  )
})
